import { useEffect, useState } from "react";
import { resolveApiUrl } from "../api-client";
import { readDevice, writeDevice, readArea, type Area } from "./device-store";
export type Region = { code: string; sidoCode: string; sidoName?:string|null; sidoAliases?:readonly string[]; name: string; lon: number; lat: number; activeCaseCount: number };
export type RegionLinks = { code: string; path: string; neighbors: Array<{code: string; name: string; path: string}> };
export function useRegions() {
  const [regions, setRegions] = useState<Region[]>(() => {const v=readDevice<unknown>("arabom:regions", []);return Array.isArray(v)?v:[];});
  const [links, setLinks] = useState<RegionLinks[]>(() => {const v=readDevice<unknown>("arabom:region-links", []);return Array.isArray(v)?v:[];});
  const [error, setError] = useState(false);
  const load = () => { setError(false); void Promise.all([
    fetch(resolveApiUrl("/api/v1/regions")).then(r => { if (!r.ok) throw Error("regions"); return r.json() as Promise<{items: Region[]}>; }),
    fetch("/region-link-graph.json").then(r => { if (!r.ok) throw Error("links"); return r.json() as Promise<{regions: RegionLinks[]}>; }),
  ]).then(([r,l]) => { setRegions(r.items); setLinks(l.regions); writeDevice("arabom:regions",r.items); writeDevice("arabom:region-links",l.regions); }).catch(() => setError(true)); };
  useEffect(load, []);
  return { regions, links, error, reload: load };
}
export function areaCodes(area: Area | null, links: RegionLinks[]): string[] {
  if (!area) return [];
  return [area.sigunguCode, ...(area.includeNeighbors ? links.find(r => r.code === area.sigunguCode)?.neighbors.map(n => n.code) ?? [] : [])];
}
export function useArea() {
  const [area, setArea] = useState(readArea);
  useEffect(() => { const changed = () => {const next=readArea();setArea(current=>JSON.stringify(current)===JSON.stringify(next)?current:next);}; addEventListener("arabom:device-change",changed); return () => removeEventListener("arabom:device-change",changed); }, []);
  return area;
}
